export default "__VITE_ASSET__CjJm98o3__"